import uuid from "react-uuid";
import { BsGrid1X2Fill } from "react-icons/bs";
import { BsBuildingsFill } from "react-icons/bs";
import { RiUserSearchFill } from "react-icons/ri";
import { TbReportSearch } from "react-icons/tb";
import { FaHandshakeSimple } from "react-icons/fa6";

export const menuItems = [
  {
    id: uuid(),
    multiple: false,
    name: "Dashboard",
    menuLink: "/kohere/Dashboard",
    active: "Dashboard",
    icon: BsGrid1X2Fill,
  },
  {
    id: uuid(),
    multiple: false,
    name: "Company Details",
    menuLink: "/kohere/Companydetails",
    active: "Company Details",
    icon: BsBuildingsFill,
  },
  /* {
    id: uuid(),
    multiple: false,
    name: "My Search",
    menuLink: "/kohere/mysearch",
    active: "My Search",
    icon: RiUserSearchFill,
  }, */
  {
    id: uuid(),
    multiple: false,
    name: "My History",
    menuLink: "/kohere/myhistory",
    active: "My History",
    icon: TbReportSearch,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My Kohere",
    menuLink: "/kohere/mykohere",
    active: "My Koheres",
    icon: FaHandshakeSimple,
  },
  {
    id: uuid(),
    multiple: false,
    name: "My Credits",
    menuLink: "/kohere/mycredits",
    active: "My Credits",
    icon: FaHandshakeSimple,
  },
];
